import { asyncMap } from './asyncMap';
import { blobToHashedBlob } from './blobToHashedBlob';
import { type Hashinator } from './domain';

export const hashinator: Hashinator = (blobs$, { hasher, concurrency }) =>
	asyncMap(blobToHashedBlob(hasher), concurrency)(blobs$);
